<template lang="pug">
.button-tabs
  slot
</template>
<script>
export default {
  name: 'button-tabs'
};
</script>
<style scoped lang="scss">
.button-tabs {
  position: relative;
  top: 0.25rem;
  padding-top: 0.75rem;
  display: flex;
}
</style>
